<div class="spinner-border" [style.border-width]="'2px'" role="status">
  <span class="sr-only">Loading...</span>
</div>
